import React, { FC } from 'react';


const RuneContainer: FC = ({children}) => (
    <div className="rune-container">
        {children}
    </div>
)
export default RuneContainer;